import React, {useContext, useEffect} from "react";
import {Colors} from "../colors";
import AppConfigContext from "../../../contexts/AppConfigContext";
import {Image, ScrollView, View} from "react-native";
import MainHeader from "../assets/MainHeader";
import {HeaderComponents, headerHeight} from "../components/CircleSpinner";
import {useFocusEffect} from "@react-navigation/native";
import OrderItem from "../../../rest/jtmc/models/OrderItem";
import {MenuDetails} from "../../../rest/jtmc/models/MenuDetails";
import {OrderContext} from "../../../contexts/OrderContext";
import {ColumnSpace, RowSpace} from "../components/_CommonComponents";
import Text from "../components/Text";
import {MenuActionButtonStyles} from "../styles";
import {
    GamesPageActionButton,
    ProfilePageActionButton,
    ServicesPageActionButton,
    WaiterCallButton
} from "../components/MenuActionsComponents";
import Button from "../components/Button";
import * as Navigator from "../../../refrences/RootNavigation";
import OrderProgressScreenFunction from "../../../components/screen-functions-components/OrderProgressScreenFunction";
import OrderProgressComponents from "../../../components/functional-components/OrderProgressComponents";
import {AppFunctionsContext} from "../../../contexts/AppFunctionsContext";
import OrderProgressActionView from "../components/OrderProgressActionView";
import NewHeader from "../components/NewHeader";
export default function OrderProgress({route, navigation}: any) {
    const configContext = useContext(AppConfigContext);
    const orderContext = useContext(OrderContext);

    const {menuDetails}: { menuDetails: MenuDetails } = route.params;

    useFocusEffect(() => {
        configContext.setPageTitle("");
        configContext.setIfPageHasHeader(false);
    });

    const orderItems = orderContext.order?.items.map((item, index) => {
        return <OrderItemView key={index} orderItem={item}/>
    });

    return <OrderProgressScreenFunction>
        {/* <View style={{height: headerHeight, width: "100%"}}>
            <MainHeader style={{position: "absolute", width: "100%"}} height={headerHeight}/>
            <View style={{position: "absolute", width: "100%", height: headerHeight}}>
                <HeaderComponents menuDetails={menuDetails}/>
            </View>
        </View> */}
        <View><NewHeader menuDetails={menuDetails}/></View>
        <PageContent>
            <View style={{padding:10,paddingBottom:5}}><Text>جزئیات سفارش شما</Text></View>
            <OrderProgressComponents orderContext={orderContext}>

                {orderItems}
                <ColumnSpace/>

                <OrderProgressBar stageNumber={orderContext.order?.currentStageNumber() ?? 0}/>
                <ColumnSpace/>

                <Text role="status-text"/>
                <ColumnSpace/>

                <Text role="time-text"/>
                <View style={{flexGrow: 1}}/>

                <Button role="back-button"/>

            </OrderProgressComponents>

        </PageContent>
        <OrderProgressActionView optionsAccess={menuDetails.menuOptionsAccess}/>

    </OrderProgressScreenFunction>
}

function OrderProgressBar(props: { stageNumber: number }) {
    const colors = Colors.instanceNoServerColor(useContext(AppConfigContext).theme, useContext(AppConfigContext).color);
    // Todo: setup progress bar by time
    return <View style={{
        borderRadius: 15,
        flexDirection: "row",
        height: 16,
        overflow: "hidden",
        backgroundColor: colors.get("lowConBackground") as string
    }}>
        <View style={{
            height: "100%",
            width: `${(props.stageNumber + 1) * 12.5}%`,
            backgroundColor: colors.get("green") as string
        }}/>
    </View>
}

function PageContent(props: any) {
    return <View style={{
        width: "100%",
        height: "100%",
        position: "absolute",
        overflow: "visible",
        paddingHorizontal: 12,
        top: 0,
        bottom: 0,
        zIndex: -1
    }}>
        <ScrollView contentContainerStyle={{flexGrow: 1}} style={{paddingTop: headerHeight, paddingBottom: 80}}>
            <ColumnSpace/>
            {props.children}
        </ScrollView>
    </View>;
}

function OrderItemView(props: { orderItem: OrderItem }) {
    const colors = Colors.instanceNoServerColor(useContext(AppConfigContext).theme, useContext(AppConfigContext).color);

    return <View style={{
        backgroundColor: colors.get("lowConBackground") as string,
        width: "100%",
        paddingVertical: 9,
        paddingHorizontal: 12,
        borderRadius: 30,
        marginVertical: 6,
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center"
    }}>
        <View style={{flexDirection: "row", alignItems: "center"}}>
            <Image style={{width: 28, height: 28}} source={{uri: props.orderItem.product.logo}}/>
            <RowSpace/>
            <Text color={colors.get("highConText") as string} weight={700}
                  size={13}>{props.orderItem.product.fullName}</Text>
        </View>
        <Text color={colors.get("highConText") as string} weight={600} size={13}>{`${props.orderItem.count} عدد`}</Text>
    </View>
}


